import locationAndHotelSearchURL from './get-location-hotel-search-url'

const fetchVoyagerLocationAndHotelSuggestions = async (
  {inputValue, cityId, showHotels}: {inputValue: string; cityId: number, showHotels: boolean},
  {signal},
) => {
  if (!inputValue) {
    return [];
  }

  const fetchVoyagerUrlForInput = locationAndHotelSearchURL({inputValue, cityId, showHotels});
  const res = await fetch(fetchVoyagerUrlForInput, {signal});
  if (!res.ok) throw new Error(res.statusText);
  const ret = await res.json();

  if (ret.data && ret.data.r) {
    return ret.data.r;
  }

  /** 🐨 handle gracefully if voyager doesn't return ret.data.r an array */
};

export default fetchVoyagerLocationAndHotelSuggestions;